console.log("[TopBar] Module loaded");

import mountMiniCart from "./miniCart";
import { GA4AddToCart } from "../lib/tracking";
import _ from "lodash";
import isMobile from "./isMobile";

export const parseAddToCartResponse = ({ data }) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(data, "text/html");
  const msg = doc.querySelectorAll(".woocommerce-message");
  const info = doc.querySelectorAll(".woocommerce-info");
  const error = doc.querySelectorAll(".woocommerce-error");

  // console.log("the msgs from woo", {
  //   msg,
  //   info,
  //   error,
  // });

  return { msg, info, error };
};

/* global wc_add_to_cart_params jQuery */
const replaceAmountStuff = (html) => {
  // console.log('replacingmayns')
  return html.replace(" amount", "");
};

export const warpFragmentRefresh = {
  url: wc_add_to_cart_params.wc_ajax_url
    .toString()
    .replace("%%endpoint%%", "get_refreshed_fragments"),
  type: "POST",
  success: (data) => {
    console.log("[TopBar] Fragment refresh received data", {
      hasData: !!data,
      hasFragments: !!data?.fragments,
      fragmentKeys: data?.fragments ? Object.keys(data.fragments) : [],
    });

    if (data && data.fragments) {
      // First, handle the top-bar-data fragment
      if (data.fragments["#top-bar-data"]) {
        console.log(
          "[TopBar] Found top-bar-data fragment, attempting to parse"
        );
        try {
          const parsedData = JSON.parse(data.fragments["#top-bar-data"]);
          console.log("[TopBar] Successfully parsed top-bar-data", {
            hasMessages: !!parsedData?.messages,
            messageCount: parsedData?.messages?.length,
          });
          updateTopBarMessages(parsedData);
        } catch (e) {
          console.error("[TopBar] Error parsing top bar data:", e);
        }
      }

      // Then handle other fragments
      jQuery.each(data.fragments, function (key, value) {
        if (value && key !== "#top-bar-data") {
          console.log("[TopBar] Processing other fragment", { key });
          if (key !== "div.currencywidget_container") {
            value = replaceAmountStuff(value);
          }
          jQuery(key).replaceWith(value);
        }
      });

      jQuery(document.body).trigger("wc_fragments_refreshed");
    }
  },
};

export const triggerFragmentRefresh = () => {
  jQuery.ajax(warpFragmentRefresh);
};

window.triggerFragmentRefresh = triggerFragmentRefresh;

/**
 * Update the top bar with new messages from AJAX response
 */
function updateTopBarMessages(topBarData) {
  console.log("[TopBar] Starting updateTopBarMessages", {
    hasMessages: !!topBarData?.messages,
    messageCount: topBarData?.messages?.length,
    settings: topBarData?.settings,
  });

  if (!topBarData || !topBarData.messages || topBarData.messages.length === 0) {
    console.log("[TopBar] No messages to display, returning");
    return;
  }

  const topBar = document.querySelector(".top-bar");
  const topBarText = document.querySelector("#custom-top-bar-message");

  console.log("[TopBar] Found DOM elements", {
    hasTopBar: !!topBar,
    hasTopBarText: !!topBarText,
    topBarId: topBar?.id,
    topBarTextId: topBarText?.id,
  });

  if (!topBar || !topBarText) {
    console.log("[TopBar] Required elements not found", {
      hasTopBar: !!topBar,
      hasTopBarText: !!topBarText,
    });
    return;
  }

  // Clear any existing ticker interval
  if (window.topBarTickerInterval) {
    console.log("[TopBar] Clearing existing ticker interval");
    clearInterval(window.topBarTickerInterval);
    window.topBarTickerInterval = null;
  }

  topBar.setAttribute(
    "data-has-calculated-country",
    topBarData.settings.hasCalculatedCountry
  );
  topBar.setAttribute("data-country", topBarData.settings.country || "");
  topBar.setAttribute("data-config", JSON.stringify(topBarData));

  topBar.id = "top-bar-container";

  if (topBarData.settings.hideTopBar || !topBarData.settings.displayTopBar) {
    topBar.style.display = "none";
    return;
  } else {
    topBar.style.display = "";
  }

  if (topBarData.styles.backgroundColor) {
    topBar.style.backgroundColor = topBarData.styles.backgroundColor;
  }

  const hasMultipleMessages = topBarData.messages.length > 1;
  console.log("[TopBar] Message setup", {
    hasMultipleMessages,
    messageCount: topBarData.messages.length,
  });

  // Remove old style element if it exists
  const oldStyle = document.getElementById("top-bar-ticker-styles");
  if (oldStyle) {
    console.log("[TopBar] Removing old style element");
    oldStyle.remove();
  }

  if (hasMultipleMessages) {
    console.log("[TopBar] Setting up multiple messages ticker");
    const styleElement = document.createElement("style");
    styleElement.id = "top-bar-ticker-styles";
    styleElement.textContent = `
      .top-bar__text {
        position: relative;
        min-height: 1.5em;
      }

      .top-bar__message {
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        transition: opacity 0.5s ease-in-out;
        visibility: hidden;
        display: block;
        width: auto;
      }

      .top-bar__message.active {
        opacity: 1;
        position: relative;
        visibility: visible;
        color: ${topBarData.styles.textColor || "inherit"};
      }
    `;
    document.head.appendChild(styleElement);

    // Clear existing content
    topBarText.innerHTML = "";

    // Add new messages
    topBarData.messages.forEach((message, index) => {
      const messageEl = document.createElement("div");
      messageEl.className = "top-bar__message" + (index === 0 ? " active" : "");
      messageEl.innerHTML = message;
      topBarText.appendChild(messageEl);
    });

    console.log(
      "[TopBar] Messages added to DOM, scheduling ticker initialization"
    );
    // Initialize ticker with a slight delay to ensure DOM is ready
    setTimeout(() => {
      console.log("[TopBar] Initializing ticker after timeout");
      setupTopBarTicker(topBarData.settings.tickInterval || 2000);
    }, 0);
  } else {
    console.log("[TopBar] Setting up single message");
    topBarText.innerHTML = topBarData.messages[0];
    if (topBarData.styles.textColor) {
      topBarText.style.color = topBarData.styles.textColor;
    }
  }
}

/**
 * Set up the ticker for multiple top bar messages
 */
function setupTopBarTicker(tickInterval) {
  console.log("[TopBar] Setting up ticker", { tickInterval });

  // Clear any existing interval
  if (window.topBarTickerInterval) {
    console.log("[TopBar] Clearing existing interval during setup");
    clearInterval(window.topBarTickerInterval);
    window.topBarTickerInterval = null;
  }

  const messages = document.querySelectorAll(".top-bar__message");
  console.log("[TopBar] Found messages", {
    messageCount: messages.length,
    messages: Array.from(messages).map((m) => ({
      text: m.textContent,
      isActive: m.classList.contains("active"),
    })),
  });

  if (!messages || messages.length <= 1) {
    console.log("[TopBar] Not enough messages for ticker, returning");
    return;
  }

  let currentIndex = 0;

  // Reset all messages to initial state
  console.log("[TopBar] Resetting message states");
  messages.forEach((msg, idx) => {
    msg.classList.remove("active");
    msg.style.position = "absolute";
    msg.style.visibility = "hidden";
    msg.style.opacity = "0";
  });

  // Set first message as active
  console.log("[TopBar] Setting first message as active");
  messages[0].classList.add("active");
  messages[0].style.position = "relative";
  messages[0].style.visibility = "visible";
  messages[0].style.opacity = "1";

  // Setup new interval
  console.log("[TopBar] Creating new ticker interval");
  window.topBarTickerInterval = setInterval(() => {
    console.log("[TopBar] Ticker tick", {
      currentIndex,
      totalMessages: messages.length,
      currentMessage: messages[currentIndex].textContent,
    });

    // Hide current message
    messages[currentIndex].classList.remove("active");
    messages[currentIndex].style.visibility = "hidden";
    messages[currentIndex].style.opacity = "0";
    messages[currentIndex].style.position = "absolute";

    // Move to next message
    currentIndex = (currentIndex + 1) % messages.length;

    // Show next message
    messages[currentIndex].classList.add("active");
    messages[currentIndex].style.visibility = "visible";
    messages[currentIndex].style.opacity = "1";
    messages[currentIndex].style.position = "relative";
  }, tickInterval);

  // Clean up interval on page unload
  window.addEventListener("beforeunload", () => {
    console.log("[TopBar] Page unloading, cleaning up ticker");
    if (window.topBarTickerInterval) {
      clearInterval(window.topBarTickerInterval);
      window.topBarTickerInterval = null;
    }
  });
}

const addToCartBtnState = (isLoading) => {
  let btns = document.querySelectorAll('button[type="submit"]');

  if (
    document.body.classList.contains("single-art-walls") ||
    document.body.classList.contains("single-perfect-pair")
  ) {
    btns = document.querySelectorAll(".buy-button");
  }

  for (let i = 0; btns.length > i; i++) {
    let btn = btns[i];
    if (isLoading) {
      // let loadingContainer = document.createElement('div')
      // let loadingInner = document.createElement('div')
      // loadingContainer.className = 'loading-component'
      // loadingInner.className = 'loading-component__loader loading-component__loader--btn'

      // loadingContainer.appendChild(loadingInner)
      if (!btn.dataset.label) {
        btn.dataset.label = btn.textContent;
      }
      btn.disabled = true;
      btn.textContent = "Adding";
      // btn.appendChild(loadingContainer)
    } else {
      // let loadingContainer = document.querySelector('.loading-component')
      // btn.removeChild(loadingContainer)
      btn.disabled = false;
      btn.textContent = "Added";
      setTimeout(() => {
        btn.textContent = btn.dataset.label;
      }, 1500);
    }
  }
};

export const addToCartSubmitCb = (e) => {
  // console.log("YOLO", e.data.clickMaster);
  e.preventDefault();

  const variationIdHiddenInput = document.querySelector(
    'input[name="variation_id"]'
  );

  if (variationIdHiddenInput && !variationIdHiddenInput.value) {
    let btns = document.querySelectorAll('button[type="submit"]');
    // console.log("btns", btns);
    for (let i = 0; btns.length > i; i++) {
      let btn = btns[i];

      if (!btn.dataset.label) {
        btn.dataset.label = btn.textContent;
      }

      btn.textContent = "Please select a size";
      btn.classList.add("error");

      jQuery("html, body").animate(
        {
          scrollTop: jQuery(".variations").offset().top - 80,
        },
        2000
      );

      setTimeout(() => {
        btn.textContent = btn.dataset.label;
        btn.classList.remove("error");
      }, 2500);
    }

    return;
  }

  let clickMaster = e.data.clickMaster;
  // console.log("clickMaster", clickMaster);

  addToCartBtnState(true);

  let product_url = window.location;
  let form = document.querySelector(".product-type-variable")
    ? jQuery(".variations_form.cart")
    : jQuery(e.currentTarget);
  // console.log("form", form);

  let button = e.currentTarget;
  let postData = form.serialize();

  const chunkArray = (array, chunkSize) => {
    let result = [];

    for (let i = 0; i < array.length; i += chunkSize) {
      result.push(array.slice(i, i + chunkSize));
    }

    return result;
  };

  let postDataChunks;

  if (button && button.dataset.target && button.dataset.target == "buy-all") {
    product_url = e.currentTarget.href;
    const split = product_url.split("add-to-cart=");
    if (split && split.length > 0) {
      const ids = split[1];
      const idsArray = ids?.split(",");

      postData = JSON.stringify({ addToCart: ids });
      postDataChunks = chunkArray(idsArray, 10);
    }
    // console.log("the product url", postData);
  }

  console.log("postDataChunks", postDataChunks);

  if (postDataChunks && postDataChunks?.length > 1) {
    Promise.all(
      postDataChunks?.map((postDataChunk) => {
        const postDataChunkString = JSON.stringify({
          addToCart: postDataChunk?.join(","),
        });

        jQuery.post(
          product_url,
          postDataChunkString + "&_wp_http_referer=" + product_url,
          function (result) {
            // console.log('result', result);
            addToCartBtnState(false);
            // let cart_dropdown = jQuery('#mini-cart', result)
            // let cart_icon = jQuery('#cart-contents', result)
            // console.log('the result', result)
            let woocommerce_success = jQuery(".woocommerce-message", result);
            let woocommerce_info = jQuery(".woocommerce-info", result);
            let woocommerce_error = jQuery(".woocommerce-error", result);
            let trackingInput = jQuery("#tpc-add-to-cart-tracking", result);

            let hasError;
            if (woocommerce_error.length > 0) {
              // console.log("has error 😞");
              for (let i = 0; i < woocommerce_error.length; i++) {
                // console.log("⛔️", woocommerce_error[i]);
              }
              hasError = true;
            } else if (woocommerce_success.length > 0) {
              hasError = false;
            }
            //console.log('success', woocommerce_success, 'info', woocommerce_info, 'error', woocommerce_error)

            // Show message
            if (hasError) {
              // console.log('1');
              jQuery(".type-product").eq(0).before(woocommerce_error);
            } else {
              // console.log('2');

              // update dropdown cart
              let errorContainer = jQuery(".woocommerce-error");
              if (errorContainer.length > 0) {
                jQuery(errorContainer).remove();
              }

              // console.log('cart_dropdown', cart_dropdown);
              // console.log('cart_icon', cart_icon);

              if (!isMobile()) {
                // const hiddenMinicart = document.getElementById("mini-cart-hidden");
                // const hiddenMinicartClone = hiddenMinicart.cloneNode(true);
                // hiddenMinicartClone.setAttribute("id", "mini-cart");
                // jQuery("#mini-cart").replaceWith(hiddenMinicartClone);
              }

              // console.log('hiddenMinicart', hiddenMinicart);
              // hiddenMinicart.setAttribute("id", "mini-cart");
              // jQuery('#mini-cart').replaceWith(hiddenMinicart)
              // const replacedMiniCart = document.getElementById('mini-cart-hidden')
              // replacedMiniCart.setAttribute("id", "mini-cart");
              // console.log(document.querySelectorAll('#mini-cart-hidden'));
              // jQuery('#cart-contents').replaceWith(cart_icon)

              if (trackingInput) {
                if (trackingInput.length > 1) {
                  const trackingData = [];
                  for (let i = 0; trackingInput.length > i; i++) {
                    const input = jQuery(trackingInput[i]);
                    trackingData.push(jQuery(input).data());
                  }
                  GA4AddToCart({ items: trackingData });
                } else {
                  const trackingData = jQuery(trackingInput).data();
                  GA4AddToCart({ items: [trackingData] });
                }
              }
            }
            // console.log("before ajax");

            // update fragments
            jQuery.ajax(warpFragmentRefresh);

            console.log("🧺 before mountMiniCart function");

            mountMiniCart(clickMaster);
          }
        );
      })
    );
  } else {
    jQuery.post(
      product_url,
      postData + "&_wp_http_referer=" + product_url,
      function (result) {
        // console.log('result', result);
        addToCartBtnState(false);
        // let cart_dropdown = jQuery('#mini-cart', result)
        // let cart_icon = jQuery('#cart-contents', result)
        // console.log('the result', result)
        let woocommerce_success = jQuery(".woocommerce-message", result);
        let woocommerce_info = jQuery(".woocommerce-info", result);
        let woocommerce_error = jQuery(".woocommerce-error", result);
        let trackingInput = jQuery("#tpc-add-to-cart-tracking", result);

        let hasError;
        if (woocommerce_error.length > 0) {
          // console.log("has error 😞");
          for (let i = 0; i < woocommerce_error.length; i++) {
            // console.log("⛔️", woocommerce_error[i]);
          }
          hasError = true;
        } else if (woocommerce_success.length > 0) {
          hasError = false;
        }
        //console.log('success', woocommerce_success, 'info', woocommerce_info, 'error', woocommerce_error)

        // Show message
        if (hasError) {
          // console.log('1');
          jQuery(".type-product").eq(0).before(woocommerce_error);
        } else {
          // console.log('2');

          // update dropdown cart
          let errorContainer = jQuery(".woocommerce-error");
          if (errorContainer.length > 0) {
            jQuery(errorContainer).remove();
          }

          // console.log('cart_dropdown', cart_dropdown);
          // console.log('cart_icon', cart_icon);

          if (!isMobile()) {
            // const hiddenMinicart = document.getElementById("mini-cart-hidden");
            // const hiddenMinicartClone = hiddenMinicart.cloneNode(true);
            // hiddenMinicartClone.setAttribute("id", "mini-cart");
            // jQuery("#mini-cart").replaceWith(hiddenMinicartClone);
          }

          // console.log('hiddenMinicart', hiddenMinicart);
          // hiddenMinicart.setAttribute("id", "mini-cart");
          // jQuery('#mini-cart').replaceWith(hiddenMinicart)
          // const replacedMiniCart = document.getElementById('mini-cart-hidden')
          // replacedMiniCart.setAttribute("id", "mini-cart");
          // console.log(document.querySelectorAll('#mini-cart-hidden'));
          // jQuery('#cart-contents').replaceWith(cart_icon)

          if (trackingInput) {
            if (trackingInput.length > 1) {
              const trackingData = [];
              for (let i = 0; trackingInput.length > i; i++) {
                const input = jQuery(trackingInput[i]);
                trackingData.push(jQuery(input).data());
              }
              GA4AddToCart({ items: trackingData });
            } else {
              const trackingData = jQuery(trackingInput).data();
              GA4AddToCart({ items: [trackingData] });
            }
          }
        }
        // console.log("before ajax");

        // update fragments
        jQuery.ajax(warpFragmentRefresh);

        console.log("🧺 before mountMiniCart function");

        mountMiniCart(clickMaster);
      }
    );
  }
};
